import { createLogger } from "./logging.ts";
import { captureErrorWithPayload } from "./error.ts";
import { createDefaultOptions } from "./ky.ts";
import ky, { isHTTPError, type Options } from "ky";

const APM_ERROR_KEYS = {
	tag: "ft9-benefit-detailview-activation-failed",
	sheet: "ft9-benefit-sheet-activation-failed",
};

export enum ActivationResponseType {
	Activated = 0,
	Conflict = 1,
	Error = 2,
}

export class ActivationClient {
	async activateByUrl(
		activationUrl: string,
		errorLoggingPayload: object,
		namespace: "tag" | "sheet",
		overrides: Partial<Options> = {},
	): Promise<ActivationResponseType> {
		const log = createLogger(namespace, "activation-client");
		const apmErrorKey = APM_ERROR_KEYS[namespace];
		const apmErrorLabels = { service: namespace, module: "activation-client", team: "ft9" };
		const headers = { "X-Requested-With": "XMLHttpRequest" };

		log.info(`Call ${activationUrl} to activate benefit using following headers: ${JSON.stringify(headers)}`);

		try {
			const response = await ky.post(activationUrl, {
				...createDefaultOptions(log, activationUrl),
				headers,
				timeout: 1000,
				...overrides,
			});

			/*                                                                            */
			/*                           */
			if (response.status !== 200) {
				return ActivationResponseType.Error;
			}

			return ActivationResponseType.Activated;
		} catch (e: unknown) {
			if (!isHTTPError(e)) {
				const custom = { ...errorLoggingPayload, failing_reason: "error" };
				captureErrorWithPayload({ message: "Activation failed", type: apmErrorKey, labels: apmErrorLabels, custom, payload: e });

				return ActivationResponseType.Error;
			}

			const { response } = e;
			const custom = {
				...errorLoggingPayload,
				status_code: response.status,
				response_type: response.type,
			};
			captureErrorWithPayload({ message: "Response is not OK", type: apmErrorKey, labels: apmErrorLabels, custom, payload: response.status });

			return response.status === 409 ? ActivationResponseType.Conflict : ActivationResponseType.Error;
		}
	}
}
